// const BASE_URL = "http://localhost:1107/api/admin";
// const HOST = "http://localhost:1107/";

const BASE_URL = "https://api.tinbox.app/api/admin";
const HOST = "https://api.tinbox.app/";

export { BASE_URL, HOST };
